<!--Agent Card-->
<div class="row">

  <div class="col-12 col-md-10 col-lg-8 col-xl-6">
    <lus-agent-card></lus-agent-card>
  </div>

  <!--CoBranding-->
  <ng-container *ngIf="LgvSettingsService.ShowCoBranding$ | async">
      <div class="col-12 col-md-10 col-lg-8 col-xl-6">
          <lus-agent-card ShowingTwoAgents="true" IsCoBrandedAgent="false"></lus-agent-card>
      </div>
  </ng-container>

</div>
